import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { Card } from '../components/ui/card';
import { UserPlus, Users } from 'lucide-react';

export default function RFQChoice() {
  const navigate = useNavigate();

  return (
    <Layout>
      <div data-testid="rfq-choice-page" className="max-w-4xl mx-auto">
        <div className="mb-8 text-center">
          <h2 className="text-3xl font-semibold text-[#0A2540] mb-2">Create New RFQ</h2>
          <p className="text-gray-600">Choose customer type to proceed</p>
          <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg inline-block">
            <p className="text-sm text-blue-800">
              <strong>Important:</strong> If customer already exists, select "Existing Customer" to keep the same TAC code
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <Card
            data-testid="new-customer-card"
            onClick={() => navigate('/customer-registration')}
            className="p-8 cursor-pointer hover:shadow-xl transition-all border-2 border-gray-200 hover:border-[#0A2540] group"
          >
            <div className="text-center">
              <div className="w-20 h-20 bg-[#0A2540] group-hover:bg-[#0d2f52] rounded-full flex items-center justify-center mx-auto mb-6 transition-colors">
                <UserPlus className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-semibold text-[#0A2540] mb-3">New Customer</h3>
              <p className="text-gray-600">Register a new customer and create RFQ</p>
            </div>
          </Card>

          <Card
            data-testid="existing-customer-card"
            onClick={() => navigate('/rfq-registration?existing=true')}
            className="p-8 cursor-pointer hover:shadow-xl transition-all border-2 border-gray-200 hover:border-[#0A2540] group"
          >
            <div className="text-center">
              <div className="w-20 h-20 bg-[#0A2540] group-hover:bg-[#0d2f52] rounded-full flex items-center justify-center mx-auto mb-6 transition-colors">
                <Users className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-semibold text-[#0A2540] mb-3">Existing Customer</h3>
              <p className="text-gray-600">Create RFQ for registered customer</p>
            </div>
          </Card>
        </div>
      </div>
    </Layout>
  );
}